import environment from "src/utils/environment";

export const VideoErrorType = {
  SLOW: "slow",
  NOT_INCOMMING: "notIncomming"
};

export default function createVideoErrorManager({ getPeerConnection, onChange }) {
  let currentErrorId = null;
  let intervalId = null;

  const errors = {
    [VideoErrorType.NOT_INCOMMING]: {
      id: VideoErrorType.NOT_INCOMMING,
      fpsThreshold: 0
    },
    [VideoErrorType.SLOW]: {
      id: VideoErrorType.SLOW,
      fpsThreshold: 10
    }
  };

  function getErrorForCollectedFps(collectedFps) {
    if (collectedFps.length === 0) return null;

    const isFpsAccetable = collectedFps.some((fps) => fps > errors[VideoErrorType.SLOW].fpsThreshold);
    if (isFpsAccetable) {
      return null;
    }

    const hasSomeFps = collectedFps.some((fps) => fps > errors[VideoErrorType.NOT_INCOMMING].fpsThreshold);
    if (hasSomeFps) {
      return errors[VideoErrorType.SLOW];
    } else {
      return errors[VideoErrorType.NOT_INCOMMING];
    }
  }

  function updateCurrentError(collectedFps) {
    const newError = getErrorForCollectedFps(collectedFps);
    const newErrorId = newError ? newError.id : null;
    if (newErrorId !== currentErrorId) {
      currentErrorId = newErrorId;
      onChange(newErrorId);
    }
  }

  function start() {
    let intervalCounter = 0;
    let lastFramesReceived = 0;
    let collectedFps = [];

    async function collectFps() {
      const peerConnection = getPeerConnection();
      if (peerConnection == null) return;
      const receiver = peerConnection.getReceivers()[0];

      if (receiver) {
        const stats = await receiver.getStats();
        stats.forEach((stat = {}) => {
          if (stat.type !== "track" || stat.kind !== "video") return;

          if (stat.framesReceived < lastFramesReceived) {
            lastFramesReceived = 0;
          }

          collectedFps.push(stat.framesReceived - lastFramesReceived);
          lastFramesReceived = stat.framesReceived;
        });
        // in browser, not every stat has framesReceived
        // which means after a bit of time, the collectedFps will
        // be resolved as too low, which triggers NOT_INCOMMING
        if (!environment.isBrowser) {
          if (collectedFps.length === 0) collectedFps.push(0);
        }
      }
    }

    intervalId = setInterval(() => {
      collectFps();

      intervalCounter++;
      const framesCommingAgain =
        currentErrorId === VideoErrorType.NOT_INCOMMING && collectedFps[collectedFps.length - 1] > 0;

      const shouldUpdate = intervalCounter === 5 || framesCommingAgain;

      if (shouldUpdate) {
        updateCurrentError(collectedFps);
        collectedFps = [];
        intervalCounter = 0;
      }
    }, 1000);
  }

  function stop() {
    clearInterval(intervalId);
  }

  function destroy() {
    onChange = null;
    clearInterval(intervalId);
  }

  return { start, stop, destroy };
}
